import { Route, Switch } from 'react-router-dom'
import { PortalArtigosEditar } from './PortalArtigosEditar'
import { PortalArtigosView } from './PortalArtigosView'

export function PortalArtigos() {
  return (
    <Switch>
      <Route path="/portal-artigos/novo" component={PortalArtigosEditar} />
      <Route path="/portal-artigos/:artigoId" component={PortalArtigosEditar} />
      <Route component={PortalArtigosView} />
    </Switch>
  )
}
